export default __webpack_public_path__ + "static/media/chevron-right.0663d7e8.svg";